import axiosInstance from "./axiosInstance";

export const fetchForm = async (formId) => {
    try {
        const response = await axiosInstance.get(`/forms/${formId}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching form:", error);
        throw error;
    }
};

export const submitForm = async (formId, submissionData) => {
    try {
        const response = await axiosInstance.post(`/forms/${formId}/submit`, {
            submission: submissionData,
        });
        return response.data;
    } catch (error) {
        console.error("Error submitting form:", error);
        throw error;
    }
};
